var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelivery(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 15,
    viewBox: "0 0 21 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.375 11.8763C17.375 12.4288 17.1336 12.9587 16.7038 13.3494C16.274 13.7401 15.6911 13.9596 15.0833 13.9596C14.4755 13.9596 13.8927 13.7401 13.4629 13.3494C13.0331 12.9587 12.7917 12.4288 12.7917 11.8763C12.7917 11.3238 13.0331 10.7939 13.4629 10.4032C13.8927 10.0125 14.4755 9.79297 15.0833 9.79297C15.6911 9.79297 16.274 10.0125 16.7038 10.4032C17.1336 10.7939 17.375 11.3238 17.375 11.8763ZM8.20833 11.8763C8.20833 12.4288 7.96689 12.9587 7.53712 13.3494C7.10735 13.7401 6.52445 13.9596 5.91667 13.9596C5.30888 13.9596 4.72598 13.7401 4.29621 13.3494C3.86644 12.9587 3.625 12.4288 3.625 11.8763C3.625 11.3238 3.86644 10.7939 4.29621 10.4032C4.72598 10.0125 5.30888 9.79297 5.91667 9.79297C6.52445 9.79297 7.10735 10.0125 7.53712 10.4032C7.96689 10.7939 8.20833 11.3238 8.20833 11.8763Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7913 11.876H8.20801M13.2497 10.2093V3.12598C13.2497 1.94764 13.2497 1.35848 12.8463 0.992643C12.4448 0.625977 11.7968 0.625977 10.4997 0.625977H4.08301C2.78684 0.625977 2.13876 0.625977 1.73634 0.992643C1.33301 1.35764 1.33301 1.94681 1.33301 3.12598V9.79264C1.33301 10.5718 1.33301 10.961 1.51726 11.251C1.63793 11.441 1.8115 11.5988 2.02051 11.7085C2.33951 11.876 2.76759 11.876 3.62467 11.876M13.708 2.70931H15.3589C16.1198 2.70931 16.5002 2.70931 16.8155 2.87181C17.1308 3.03348 17.3261 3.33014 17.7175 3.92348L19.2749 6.28181C19.4693 6.57681 19.5664 6.72514 19.6168 6.88848C19.6663 7.05264 19.6663 7.22431 19.6663 7.56848V9.79264C19.6663 10.5718 19.6663 10.961 19.4821 11.251C19.3614 11.441 19.1879 11.5988 18.9788 11.7085C18.6598 11.876 18.2318 11.876 17.3747 11.876",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.53358 7.29264L5.17142 6.31431C4.44633 5.79264 4.08333 5.53264 4.08333 5.20931M4.08333 5.20931C4.08333 4.88598 4.44633 4.62598 5.17142 4.10431L6.53358 3.12598M4.08333 5.20931H10.5",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelivery);
export default __webpack_public_path__ + "static/media/delivery.5604edd5ff19df39311eee48ea7f3973.svg";
export { ForwardRef as ReactComponent };